<template>
    <!-- 物品类别 -->
    <div>
        <div style="font-size:20px;float:left;margin:40px;font-weight:600">物品类别</div>

        <!-- 列表 -->
        <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <div style="height:40px"></div>
                <span>物品类别 </span>
                <el-input v-model="condition.data" placeholder="请输入内容" style="width:180px;"></el-input>

                <!-- 按钮 -->
                <div style="display:inline-block;margin-left:20px">
                    <el-button type="goon" @click="Find">查询</el-button>
                    <el-button type="goon" @click="AddFrom">新增</el-button>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:30px 3% 0 3%">
                <el-row>
                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
                        tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="80">
                        </el-table-column>
                        <el-table-column label="序号">
                            <template slot-scope="scope_1">
                                {{scope_1.$index + 1}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="data" align="center" label="物品类别">
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" label="生成时间">
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <img src="../../assets/编辑.png" @click="UpdateFrom(scope.row)">
                                <img src="../../assets/删除.png" @click="Del(scope.row.id)"
                                    style="margin-left: 10px" />
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>

        </div>

        <!-- 详情 -->
        <div>
            <el-dialog :title="from.id == null || from.id == '' ? '添加物品类别' : '修改物品类别'" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false"
                :center="true">

                <el-form :model="from" :rules="rules" ref="from" style="padding: 0 10%;" label-width="100px">
                    <el-form-item label="物品类别" prop="data">
                        <el-input v-model="from.data" placeholder="请输入物品类别" style="width: 100%;"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align: center;" label-width="0px">
                        <el-button type="primary" @click="Add" v-show="from.id == null || from.id == ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
                        <el-button type="primary" @click="Update" v-show="from.id != null && from.id != ''"
                            style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
                    </el-form-item>
                </el-form>

            </el-dialog>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {

                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //条件
                condition: {
                    data: "",
                },

                //复选框ids
                ids: [],

                //页面相关
                dialogVisible: false,

                //表单数据
                from: {
                    id: "",
                    data: "",
                },

                //表单验证
                rules: {
                    data: [{
                        required: true,
                        message: '请输入物品类别！',
                        trigger: 'blur'
                    }],
                }

            }
        },
        methods: {
            //列表复选框选择操作
            handleSelectionChange(val) {
                this.ids = [];
                e.forEach(item => {
                    this.ids.push(item.id);
                })
            },
            //添加页面
            AddFrom() {
                this.trash();
                this.dialogVisible = true;
            },
            //添加操作
            Add() {
                this.$refs["from"].validate(async (valid) => {
                    if (valid) {
                        var url = "dictionaries/add";
                        var record = {
                            data_name: "物品类别",
                            data: this.from.data,
                            data_grouping: "article_type"
                        };
                        var data = await this.$globals.AxiosPost(url, record);
                        if (data === "-2000") {
                            this.$message.error("服务器未响应！请稍后重试");
                        } else {
                            var code = data.code;
                            var data = data.data;
                            if (code === '200') {
                                this.$message.success(data);
                                this.dialogVisible = false;
                                this.trash();
                                this.Find();
                            } else {
                                this.$message.warning(data);
                            }
                        }
                    }
                });
            },
            //编辑页面
            UpdateFrom(e) {
                this.from.id = e.id;
                this.from.data = e.data;
                this.dialogVisible = true;
            },
            //编辑操作
            Update() {
                this.$refs["from"].validate(async (valid) => {
                    if (valid) { 
                        var url = "dictionaries/modify";
                        var record = {
                            id: this.from.id,
                            data_name: "物品类别",
                            data: this.from.data,
                            data_grouping: "article_type"
                        };
                        var data = await this.$globals.AxiosPost(url, record);
                        if (data === "-2000") {
                            this.$message.error("服务器未响应！请稍后重试");
                        } else {
                            var code = data.code;
                            var data = data.data;
                            if (code === '200') {
                                this.$message.success(data);
                                this.dialogVisible = false;
                                this.trash();
                                this.Find();
                            } else {
                                this.$message.warning(data);
                            }
                        }
                    }
                });
            },
            //删除
            async Del(e) {
                var url = "dictionaries/del";
                var record = {
                    ids: [e]
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.dialogVisible = false;
                        this.trash();
                        this.Find();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //分页
            handleCurrentChange(val) {
                this.page_num = val;
                this.Find();
            },
            //查询
            async Find() {
                var url = "dictionaries/find";
                var record = {
                    page_num: this.page_num,
                    page_size: this.page_size,
                    data_grouping: "article_type",
                    data: this.condition.data
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === "-2000") {
                    this.$message.error("服务器未响应！请稍后重试");
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.warning("请求失败！请稍后重试");
                    }
                }
            },
            //清除数据
            trash() {
                this.from.data = "";
                this.from.id = "";
            }
        },
        created() {
            this.Find();
        }
    }
</script>

<style>
    .el-button--goon:focus,
    .el-button--goon:hover {
        background: #006E4B;
        color: #fff;
    }

    .el-button--goon {
        color: #FFF;
        background-color: #006E4B;
        width: 85px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// article_type.vue?e98be632